import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataManagementDashboardComponent } from './components/dashboard/dashboard.component';
import { ImpersonateComponent } from './components/impersonate/impersonate.component';
import { GlobalDataManagementComponent } from './global-data-management.component';

const routes: Routes = [
	{
		path: '',
		component: GlobalDataManagementComponent,
		children: [
			{
				path: '',
				component: DataManagementDashboardComponent,
			},
			{
				path: 'impersonate',
				component: ImpersonateComponent,
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class GlobalDataManagementRoutingModule {}
